import { Inbox, MessageCircle, Users, Bot } from "lucide-react";
import heroImage from "@/assets/hero-person-inbox.png";
import ProductHeroI18n from "../shared/ProductHeroI18n";

const OmnichannelInboxHero = () => {
  return (
    <ProductHeroI18n
      translationPrefix="inboxPage"
      heroImage={heroImage}
      imageAlt="Chathero Unified Inbox"
      floatingIcons={[
        { icon: Inbox, color: "mint" },
        { icon: MessageCircle, color: "orange" },
        { icon: Users, color: "primary" },
        { icon: Bot, color: "mint" },
      ]}
    />
  );
};

export default OmnichannelInboxHero;
